import { RotateSolid } from '@allocab/allocab-icons';
import { useSearchParams } from 'react-router-dom';

import { FilterBadge } from '../../components/FilterBadge';
import { useFetchUser } from '../../hooks/useFetchUser';
import { t } from '../../services/translation/translation';

export const TO_ASSIGN_SEARCH_PARAMS_KEY = 'toAssign';

type Props = {
  onChange: (_key: string, _value: string | undefined) => void;
};

export const TripToAssignFilter = ({ onChange }: Props) => {
  const [searchParams] = useSearchParams();
  const toAssign = searchParams.get(TO_ASSIGN_SEARCH_PARAMS_KEY);
  const { data: user } = useFetchUser();

  const toggle = () => {
    if (toAssign === 'true') {
      onChange(TO_ASSIGN_SEARCH_PARAMS_KEY, undefined);
    } else {
      onChange(TO_ASSIGN_SEARCH_PARAMS_KEY, 'true');
    }
  };

  return (
    <div className="relative flex items-center justify-center">
      <FilterBadge onClick={toggle} isActive={!!user && toAssign === 'true'} isDisabled={!user}>
        <RotateSolid width={12} height={12} className="fill-current" />
        <span>{t('trips-list-route.to-assign')}</span>
      </FilterBadge>
    </div>
  );
};
